import React from 'react';
import PropTypes from 'prop-types';
import { textProp } from '../../../tools/customProps';

const propTypes = {
  tag: PropTypes.oneOf(['p', 'span']),
  testId: PropTypes.string,
  tmnt: textProp,
};

const defaultProps = {
  tag: 'span',
  testId: undefined,
  tmnt: undefined,
};

export default function TmntHtml({
  tag,
  testId,
  tmnt,
}) {
  if (!tmnt) return null;

  const Tag = tag;
  const { key, value } = tmnt;

  return (
    <Tag
      dangerouslySetInnerHTML={{ __html: value }}
      data-testid={testId}
      data-text-key={key}
    />
  );
}

TmntHtml.propTypes = propTypes;
TmntHtml.defaultProps = defaultProps;
